import { InjectionToken } from '@angular/core';

export interface GematikTourLabels {
  back: string;
  next: string;
  done: string;
  close: string;
  stepIndicator: (current: number, total: number) => string;
}

export const GEMATIK_TOUR_DEFAULT_LABELS: GematikTourLabels = {
  back: 'guidedTour.back',
  next: 'guidedTour.next',
  done: 'guidedTour.done',
  close: 'guidedTour.close',
  stepIndicator: (current, total) => `${current} / ${total}`,
};

/**
 * Host app can provide this token to override the default (German) tour labels, e.g. for a different locale.
 */
export const GEMATIK_TOUR_LABELS = new InjectionToken<GematikTourLabels>('gematik-tour.labels');
